import script from "./Timer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Timer.vue?vue&type=script&lang=ts&setup=true"

import "./Timer.vue?vue&type=style&index=0&id=fea093da&lang=css"

const __exports__ = script;

export default __exports__